<template>
  <div class="col into">

      <div class="modal" v-if="showIntroVideo">
        <div class="wrapper" >
          <div class="loader" v-if="!videoReady">
            <h3>Wczytywanie....</h3>
          </div>
          <div class="player" ref="pleayer">
            <youtube-media  ref="youtube" :video-id="videoId"  :player-vars="{ autoplay: 1, rel: 0 }" @ended="ended" @ready="ready"  ></youtube-media>
          </div>
          <button ref="btnStart" class="btn btn-green btnStart" @click="startGame()"><span>PRZEJDŹ DO GRY</span></button>
          <div class="ducks duck150"></div>
        </div>
      </div>
      <div v-if="showIntroVideo && retry" ref="retry" class="retry">
        <button  @click="resetVideo" class="btn retry-animation">
          <i ref="retryIcon" class="retry-icon"></i>
        </button>
      </div>
      <div  class="col-claim">
        <div ref="flag" class="cyber-duck blank">
          <div class="flag">
            <span>misja: {{missionName}}</span>
          </div>
        </div>
        <div ref="claim" class="wrap blank">
          <h1 class="claim-headline blue">zagraj w {{missionTitle}}</h1>
          <span   class="claim-headline-span"></span>
          <p class="claim-paragraph" v-html="missionAbout"></p>
          <div class="action-bar">
            <button class="btn btn-green-light"  @click="goNextView()"><span>START</span></button>
          </div>
        </div>

      </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import { TimelineLite } from 'gsap';
import VueYouTubeEmbed from 'vue-youtube-embed'
import { Howl, Howler } from 'howler';
export default {
name: "OrganismGameIntro",
  data(){
    return{
      missionName: null,
      missionNameAudio:null,
      missionTitle: null,
      missionAbout:null,
      showIntroVideo: true,
      videoId:null,
      videoReady:false,
      playerWidth:null,
      playerHeight:null,
      userInteracted: false,
      retry: false,
      gamenameGTM: '',
    }
  },
  components: {
    VueYouTubeEmbed,
  },
  computed: {
    ...mapGetters(['setupGame','hangmanGame','memoryGame','shopGame']),
    player() {
      return this.$refs.youtube.player
    }
  },
  methods: {
    ...mapActions([ 'gotoNextView', 'audioPlayer','stopAudio']),


    startGame(){
      if (this.setupGame.gameType == 1){
        this.missionNameAudio = '/bankoslowka/ogolne/BNP_Samodzielniak_3_A i B.mp3';
        this.gamenameGTM = "Pieniądze od podszewki"
      }else if(this.setupGame.gameType == 2){
        this.missionNameAudio = '/memory/ogolne/mission_name.mp3';
        this.gamenameGTM = "Misja bezpieczeństwo"
      }else if(this.setupGame.gameType == 3){
        this.missionNameAudio = '/shop/ogolne/mision_name.mp3';
        this.gamenameGTM = "Zarządzam budżetem"
      }
      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - PRZEJDŹ DO GRY",
        label: this.gamenameGTM + ": Animacja wideo",  //  gameType
      })

      this.showIntroVideo = false;
      const timeline = new TimelineLite()
      const { flag } = this.$refs
      const { claim } = this.$refs
      timeline
          .to(flag,  { opacity: 1, x: -860, y:0,})
          .to(claim,  {opacity: 1, y:0,})


      this.audioPlayer({
        'url': [
          this.missionNameAudio,
          '/intro/click_start.mp3'
        ],
      })
    },

    goNextView(){

      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - START",
        label: this.gamenameGTM + ": Start gry",  //  gameType
      })

      this.stopAudio()
      this.gotoNextView(2);
        if (this.setupGame.gameType == 1){
          this.ruleAudio = '/bankoslowka/ogolne/rules.mp3';
        }else if(this.setupGame.gameType == 2){
          this.ruleAudio = '/memory/ogolne/memory_rules.mp3';
        }else if(this.setupGame.gameType == 3){
          this.ruleAudio = '/shop/ogolne/shop_rules.mp3';
        }
        this.audioPlayer({
          'url': [
            this.ruleAudio,
            '/intro/click_rules.mp3'
          ],
        })
    },

    resetVideo(){
        this.player.playVideo()
    },
    ready () {
      this.videoReady = true;
      const timeline = new TimelineLite()
      const { pleayer } = this.$refs
      const { btnStart } = this.$refs

      if (window.innerWidth < 800) {
        timeline
            .set(pleayer,  { scale: 0.1, transformOrigin: '50% 50%'})
            .to(pleayer, { y: 1205, scale: 1,} )
            .set(btnStart,  {   scale: 0.1, transformOrigin: '50% 50%'})
            .to(btnStart,  { opacity: 1, scale: 1,})
      }else{
        timeline
            .set(pleayer,  { scale: 0.1, transformOrigin: '50% 50%'})
            .to(pleayer, { y: 1300, scale: 1,} )
            .set(btnStart,  { scale: 0.1, transformOrigin: '50% 50%'})
            .to(btnStart,  {opacity: 1,  scale: 1,})
      }

    },
    ended() {
      this.retry = true;
    },

  },
  mounted() {
    if (this.setupGame.gameType == 1){
      this.videoId = this.hangmanGame.videId;
      this.missionName = this.hangmanGame.missionName;
      this.missionTitle = this.hangmanGame.gameName;
      this.missionAbout = this.hangmanGame.gameAbout;

    }else if(this.setupGame.gameType == 2){
      this.videoId = this.memoryGame.videId;
      this.missionName = this.memoryGame.missionName;
      this.missionTitle = this.memoryGame.gameName;
      this.missionAbout = this.memoryGame.gameAbout;

    }else{
      this.videoId = this.shopGame.videId;
      this.missionName = this.shopGame.missionName;
      this.missionTitle = this.shopGame.gameName;
      this.missionAbout = this.shopGame.gameAbout;
    }
  },
  created() {
    if (window.innerWidth < 870) {
      this.playerWidth = '600';
      this.playerHeight = '450';
    }else if(window.innerWidth < 380) {
      this.playerWidth = '300';
      this.playerHeight = '200';
    }
    else {
      this.playerWidth = '820';
      this.playerHeight = '500';
    }

  }

}
</script>

